export default {
  grayishGreen: "#bacdbe",
  stateColor: "#e9eaea",
  darkGray: "#545b62",
  pressButtonState: "rgba(200, 200, 200, 0.9)",
  redLight: "rgba(220, 53, 70, 0.3)",
};
